import { FolderTree } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

type DetailPaneEmptyStateProps = {
  title: string;
  description: string;
};

export const DetailPaneEmptyState = (props: DetailPaneEmptyStateProps) => {
  const { title, description } = props;

  return (
    <Card className="flex h-full flex-1 flex-col gap-0 py-0">
      <CardContent className="flex flex-1 flex-col items-center justify-center p-6">
        <Empty className="border-0">
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <FolderTree className="size-5" />
            </EmptyMedia>
            <EmptyTitle className="text-sm">{title}</EmptyTitle>
            <EmptyDescription className="max-w-xs text-xs">
              {description}
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      </CardContent>
    </Card>
  );
};
